import chroma from 'chroma-js';

import { EPaletteModes } from '@/types/theme-packs.types';

type TGenerateColorShadesProps = {
  color: string;
  theme?: EPaletteModes;
  nuances?: number;
};

const generateColorShades = ({ color, theme = EPaletteModes.Light, nuances = 6 }: TGenerateColorShadesProps) => {
  // using chromajs generate 5 shades of primary and 5 shades of secondaryAccentColor
  const toColor = theme === EPaletteModes.Dark ? 'white' : 'black';
  const shades = chroma.scale([color, toColor]).colors(nuances);

  // remove the last shade of each color because it's white/black
  shades.pop();

  return shades;
};

export default generateColorShades;
